import { useURLFilterState } from '@client/hooks/useURLFilterState';

/**
 * Filter keys configuration for product search
 * @type {string[]}
 */
const PRODUCT_FILTERS = [
  'product_names',
  'active_substance_names',
  'activity_sectors',
  'organic_approval',
  'cultures',
  'cultures_practices',
  'enemies',
  'commercial_packagings',
  'registration_numbers',
  'product_types',
  'activity_types',
  'allergens',
  'chemical_families',
  'pesticide_groups',
  'pesticide_categories',
  'arla_culture_groups',
  'application_types',
  'acute_toxicity',
  'long_term_effects',
  'fish_or_daphnia',
  'birds',
  'bees',
  'persistence',
  'leaching_potential',
];

/**
 * Specific hook for product filtering with URL synchronization
 * Manages filter state and URL synchronization for active product search
 * @returns {Object} Filter state and methods for active product search
 */
export const useProductFilters = () => {
  return useURLFilterState(PRODUCT_FILTERS, {
    defaultPagination: { page: 1, size: 20 },
    throttleMs: 300,
    clearOnDefault: true,
  });
};
